export function sanitizeCustomerIdForGa4(raw) {
    var _a;
    if (!raw)
        return null;
    const value = String(raw).trim();
    if (!value)
        return null;
    if (value.toUpperCase().startsWith("PK"))
        return value;
    const leadingDigits = (_a = value.match(/^(\d+)/)) === null || _a === void 0 ? void 0 : _a[1];
    return leadingDigits !== null && leadingDigits !== void 0 ? leadingDigits : null;
}
export function pushToDataLayer(action) {
    window.dataLayer.push(action);
}
export function pushGa4Event(event) {
    var _a;
    const params = Object.assign({}, ((_a = event.params) !== null && _a !== void 0 ? _a : {}));
    if (params.customer_id != null) {
        params.customer_id = sanitizeCustomerIdForGa4(params.customer_id);
    }
    window.dataLayer.push(Object.assign({ event: event.event }, params));
}
export function addGa4EventToDataLayer(action) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(action);
}
export function addEcommerceEventToDataLayer(event) {
    addGa4EventToDataLayer(event);
}
export function addCustomEventToDataLayer(action) {
    window.dataLayer.push(action);
}
